import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, homeFor } from "../context/AuthContext";

export const FullPageLoader = () => (
  <div className="min-h-screen grid place-items-center bg-[#EEF1ED]" data-testid="page-loader">
    <Loader2 className="w-7 h-7 animate-spin text-[#2F5D4A]" />
  </div>
);

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  if (user === null) return <FullPageLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
};
